import { ISVGIconProps } from '@northladder/design-system';

interface IPlayPauseSVGIconProps extends ISVGIconProps {
  isPlaying?: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * Renders a Play/Pause SVG icon with customizable height, width, and className.
 * The icon uses `currentColor` for its stroke, allowing color inheritance from parent elements.
 * Displays a play icon when not playing, and a pause icon when playing.
 */
export function PlayPauseSVGIcon({
  className,
  height = 24,
  isPlaying = false,
  width = 24,
}: IPlayPauseSVGIconProps) {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      {isPlaying ? (
        <path
          d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      <path
        d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
